/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useEffect, useState, useCallback, useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { FormattedMessage, injectIntl } from 'react-intl';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import messages from 'aurora-translations';
import isEmpty from 'lodash/isEmpty';
import ceil from 'lodash/ceil';
import qs from 'query-string';
import { keyEmptyCheck } from 'aurora-utils/utils';
import history from 'aurora-utils/history';
import { useDeepEffect } from 'aurora-hooks';
import { fetchEscrowProjects } from 'aurora-composition/modules/developers/actions';

import { CleverTapPropertiesFilter } from 'aurora-utils/cleverTap.eventhelper';

import { ADGMPagination } from 'aurora-components';
import { ADGMFilters } from 'aurora-section-components';
import FILTERS_NAMES from 'aurora-utils/filtersNames';
import Box from '@material-ui/core/Box';
import NoProject from './NoProject';
import ProjectList from './ProjectList';
import styles from './styles';

function ADGMProjects(props) {
  const {
    intl,
    classes,
    breadCrumbs,
    title,
    showTitle,
    requiredFilters,
    selectable,
    multi,
    onNext,
    onBack,
    defaultFilters,
    defaultSelected,
    state: routeState,
    onNextLoading,
    nextBtnText,
    backBtnText,
    enabledNextButton,
    pageSize,
    isPermit,
    handleSelected,
    ...restProps
  } = props;

  const {
    location: { search },
  } = history;

  const [selected, setSelected] = useState(defaultSelected);
  const query = qs.parse(search);
  const { page = 1, ...filters } = query;
  const [data, setData] = useState({});

  // const searchValue = query?.projectNumber || null;
  const searchValue = null;

  const { loading, locale, error } = useSelector(
    createSelector(
      state => state.directoryReducer,
      state => state.language,
      (employee, language) => {
        return {
          loading: employee.loading,
          error: employee.error,
          locale: language.locale,
        };
      },
    ),
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (selected) handleSelected(selected);
  }, [selected]);
  const fetchProjectsData = payload => {
    const params = { ...payload };
    if (params?.type === '' || params?.type === null) {
      params.type = null;
    }
    if (params?.type) params.type = params?.type[0] === ',' ? params?.type.slice(1) : params?.type;

    if (params?.name === '') {
      params.name = params?.name === '' ? null : params?.name;
    }
    if (params?.developerName === '') {
      params.developerName = params?.developerName === '' ? null : params?.developerName;
    }

    dispatch(fetchEscrowProjects(params)).then(res => {
      if (res.success) {
        if (isEmpty(res?.result?.projects)) {
          setData(null);
          return;
        }
        setData(res?.result || null);
      }
    });
  };

  useDeepEffect(() => {
    const payload = {
      page: page - 1,
      size: pageSize,
      // isOffplan: true,
      // isEscrowAccountExist: false,
      ...(filters[FILTERS_NAMES.PROJECT_NAME]
        ? { projectId: filters[FILTERS_NAMES.PROJECT_NAME] }
        : { projectId: null }),
      ...(filters[FILTERS_NAMES.PROJECT_NUMBER]
        ? { projectNumber: filters[FILTERS_NAMES.PROJECT_NUMBER] }
        : { projectNumber: null }),
      ...(filters[FILTERS_NAMES.DISTRICT] ? { district: filters[FILTERS_NAMES.DISTRICT] } : { district: null }),
      ...(filters[FILTERS_NAMES.COMMUNITY] ? { community: filters[FILTERS_NAMES.COMMUNITY] } : { community: null }),
      ...(filters[FILTERS_NAMES.PROJECT_TYPE]
        ? {
            type: Array.isArray(filters[FILTERS_NAMES.PROJECT_TYPE])
              ? filters[FILTERS_NAMES.PROJECT_TYPE]
              : [filters[FILTERS_NAMES.PROJECT_TYPE]],
          }
        : { type: null }),
      ...defaultFilters,
    };
    fetchProjectsData(payload);
  }, [search]);

  const requiredFiltersData = useMemo(() => {
    return requiredFilters;
  }, [requiredFilters]);

  const onNextDisabled = useMemo(() => {
    if (onNextLoading || loading || (isEmpty(selected) && enabledNextButton === false)) {
      return true;
    }
    return false;
  }, [selected, loading, onNextLoading]);

  const showFooter = useMemo(() => selectable, [selectable]);

  const handleQueryChange = useCallback(
    newQuery => {
      history.replace({
        search: qs.stringify({ id: query.id, ...newQuery }),
        state: { ...routeState },
      });
      CleverTapPropertiesFilter(newQuery);
    },
    [search],
  );

  const handlePageChange = useCallback(
    num => {
      const newQuery = { ...query, page: num };
      handleQueryChange(newQuery);
    },
    [query],
  );

  const handleResetFilters = useCallback(() => {
    let newQuery = { page: 1 };
    newQuery = {
      ...newQuery,
      ...(query.callSecondApi && { callSecondApi: query?.callSecondApi }),
    };
    handleQueryChange(newQuery);
  }, [query.type]);

  const handleNext = useCallback(() => {
    if (typeof onNext === 'function') {
      onNext(selected);
    }
  }, [selected]);

  const handleSearch = (appliedFilters, searchVal) => {
    const newQuery = {
      page: 1,
      ...appliedFilters,
      ...(searchVal && { projectNumber: searchVal }),
    };
    handleQueryChange(newQuery);
  };

  return (
    <ADGMFilters
      loading={loading}
      filtersApiParams={{
        [FILTERS_NAMES.PROJECT_NAME]: {
          isElmsProjectId: true,
        },
      }}
      breadCrumbs={breadCrumbs}
      title={!isPermit ? (title ? keyEmptyCheck(title) : keyEmptyCheck('select_a_project')) : ''}
      showTitle={showTitle}
      query={query}
      showSearchField={!isPermit}
      searchFieldPlaceHolder={intl.formatMessage({
        ...messages.search_project_number,
      })}
      searchFieldValue={searchValue}
      searchValue={searchValue}
      requiredFilters={requiredFiltersData}
      totalResults={data?.recordsTotal}
      error={error}
      onSearch={handleSearch}
      onFiltersReset={handleResetFilters}
      customClasses={{
        ...(showFooter && { root: classes.paddingBottom }),
      }}
      {...restProps}
    >
      {/* Projects List */}
      {!loading && isEmpty(data?.projects) && <NoProject />}
      {!isEmpty(data) && (
        <ProjectList
          locale={locale}
          selectable={selectable}
          multi={multi}
          selected={selected}
          setSelected={setSelected}
          data={data}
          page={page}
          history={history}
        />
      )}

      {/* Pagination */}
      {!isEmpty(data?.projects) && (
        <div className={classes.paginationHolder}>
          <ADGMPagination
            totalPages={ceil(data?.recordsTotal / pageSize)}
            currentPage={Number(page)}
            onPageChange={handlePageChange}
            customClasses={{ container: classes.pagination }}
          />
        </div>
      )}

      {/* Action buttons footer */}
      {!isPermit && showFooter && (
        <div className={classes.footer}>
          <Container className={classes.container}>
            <div className={classes.actionsWrapper}>
              <Box width={{ base: '100%', md: '25%' }} />
              <Box flex='1' display='flex' justifyContent='space-between' sx={{ gap: '24px' }}>
                {typeof onBack === 'function' ? (
                  <Button variant='contained' className={classes.backButton} onClick={onBack}>
                    {backBtnText ? keyEmptyCheck(backBtnText) : keyEmptyCheck('back')}
                  </Button>
                ) : null}

                <Button color='primary' variant='contained' onClick={handleNext} disabled={onNextDisabled}>
                  {multi ? (
                    nextBtnText ? (
                      keyEmptyCheck(nextBtnText, { s: selected?.length || 0 })
                    ) : (
                      keyEmptyCheck('selected_properties_count', {
                        count: selected?.length || 0,
                      })
                    )
                  ) : (
                    <FormattedMessage {...messages.proceed} />
                  )}
                </Button>
              </Box>
            </div>
          </Container>
        </div>
      )}
    </ADGMFilters>
  );
}

ADGMProjects.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  breadCrumbs: PropTypes.array.isRequired,
  hidePropertyToggle: PropTypes.bool,
  title: PropTypes.string,
  showTitle: PropTypes.bool,
  requiredFilters: PropTypes.array,
  selectable: PropTypes.bool,
  multi: PropTypes.bool,
  switchType: PropTypes.string,
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  defaultFilters: PropTypes.object,
  defaultSelected: PropTypes.object,
  defaultSwitchType: PropTypes.string,
  state: PropTypes.object,
  isPMA: PropTypes.bool,
  isMultiLease: PropTypes.bool,
  showSwitch: PropTypes.bool,
  showMortgageProperties: PropTypes.bool,
  onNextLoading: PropTypes.bool,
  viewLeaseUnitsHandler: PropTypes.oneOf[(PropTypes.func, null)],
  clearPropertiesOnUnMount: PropTypes.bool,
  nextBtnText: PropTypes.string,
  backBtnText: PropTypes.string,
  enabledNextButton: PropTypes.bool,
  pageSize: PropTypes.number,
  isPermit: PropTypes.bool,
  handleSelected: PropTypes.func,
};

ADGMProjects.defaultProps = {
  hidePropertyToggle: false,
  title: '',
  showTitle: false,
  requiredFilters: [],
  selectable: false,
  multi: false,
  switchType: null,
  propertyType: null,
  onNext: null,
  onBack: null,
  defaultFilters: {},
  defaultSelected: null,
  defaultSwitchType: 'lease',
  state: {},
  isPMA: false,
  isMultiLease: false,
  showSwitch: false,
  showMortgageProperties: false,
  onNextLoading: false,
  viewLeaseUnitsHandler: null,
  clearPropertiesOnUnMount: false,
  nextBtnText: '',
  backBtnText: '',
  enabledNextButton: false,
  pageSize: 10,
  isPermit: false,
  handleSelected: null,
};

export default withStyles(styles)(memo(injectIntl(ADGMProjects)));
